import history from '../history'

export default function navigate(loc: string) {
  history.push(loc)
}
